import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISlotList } from '../../../Pages/Slot/ISlot';

interface IUpdate extends IReduxState<ISlotList> {
  updateableDate?: ISlotList;
}

export const UpdateSlotOrderSlicer = createSlice({
  name: 'UpdateSlotOrder',
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateSlotOrder: (state, _) => {
      state.isLoading = true;
    },
    successUpdateSlotOrder: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateSlotOrder: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    SlotsUpdateableDataOrder: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdateSlotStateOrder: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
    clearUpdateableDataOrder: (state) => {
      state.updateableDate = undefined;
    },
  },
});

export const {
  updateSlotOrder,
  failureUpdateSlotOrder,
  successUpdateSlotOrder,
  SlotsUpdateableDataOrder,
  clearUpdateSlotStateOrder,
  clearUpdateableDataOrder,
} = UpdateSlotOrderSlicer.actions;

export default UpdateSlotOrderSlicer.reducer;
